import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import it from "@/locales/it.json";
import en from "@/locales/en.json";
import de from "@/locales/de.json";
import fr from "@/locales/fr.json";
import es from "@/locales/es.json";
import ro from "@/locales/ro.json";
import pl from "@/locales/pl.json";
import nl from "@/locales/nl.json";
import pt from "@/locales/pt.json";
import bg from "@/locales/bg.json";
import cs from "@/locales/cs.json";
import da from "@/locales/da.json";
import el from "@/locales/el.json";
import et from "@/locales/et.json";
import fi from "@/locales/fi.json";
import ga from "@/locales/ga.json";
import hr from "@/locales/hr.json";
import hu from "@/locales/hu.json";
import lt from "@/locales/lt.json";
import lv from "@/locales/lv.json";
import mt from "@/locales/mt.json";
import sk from "@/locales/sk.json";
import sl from "@/locales/sl.json";
import sv from "@/locales/sv.json";

const resources = {
  it: { translation: it },
  en: { translation: en },
  de: { translation: de },
  fr: { translation: fr },
  es: { translation: es },
  ro: { translation: ro },
  pl: { translation: pl },
  nl: { translation: nl },
  pt: { translation: pt },
  bg: { translation: bg },
  cs: { translation: cs },
  da: { translation: da },
  el: { translation: el },
  et: { translation: et },
  fi: { translation: fi },
  ga: { translation: ga },
  hr: { translation: hr },
  hu: { translation: hu },
  lt: { translation: lt },
  lv: { translation: lv },
  mt: { translation: mt },
  sk: { translation: sk },
  sl: { translation: sl },
  sv: { translation: sv },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,

    // Global fallback for any missing key in any language
    fallbackLng: ["en"],

    // Make "en-GB", "it-IT" resolve to "en", "it"
    load: "languageOnly",
    nonExplicitSupportedLngs: true,

    supportedLngs: Object.keys(resources),

    interpolation: {
      escapeValue: false,
    },

    // SPA: language stored in localStorage, otherwise default to Italian (main target market)
    detection: {
      order: ["localStorage"],
      caches: ["localStorage"],
    },

    // Use stored language (from settings or manual selection), default to Italian
    lng: localStorage.getItem('i18nextLng') || 'it',

    debug: false,
  });

export default i18n;
